module.exports = __webpack_public_path__ + "img/promed.adc64377.png";